import { Menu, Phone, X } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { contact, navItems } from '../data/site'
import { Logo } from './Logo'

export function Header() {
  const [open, setOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const menuButtonRef = useRef<HTMLButtonElement>(null)
  const location = useLocation()

  useEffect(() => setOpen(false), [location.pathname])

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    document.body.classList.toggle('menu-open', open)
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && open) {
        setOpen(false)
        menuButtonRef.current?.focus()
      }
    }
    window.addEventListener('keydown', closeOnEscape)
    return () => {
      document.body.classList.remove('menu-open')
      window.removeEventListener('keydown', closeOnEscape)
    }
  }, [open])

  const navigation = navItems.map((item) =>
    item.external ? (
      <a key={item.label} href={item.to} target="_blank" rel="noopener noreferrer">{item.label}</a>
    ) : (
      <NavLink className={({ isActive }) => `${item.featured ? 'nav-join ' : ''}${isActive ? 'active' : ''}`.trim()} key={item.label} to={item.to} end={item.to === '/'}>{item.label}</NavLink>
    ),
  )

  return (
    <header className={`site-header${scrolled ? ' site-header--scrolled' : ''}${open ? ' site-header--open' : ''}`}>
      <div className="utility-bar">
        <div className="utility-bar__inner shell">
          <a href={contact.phoneHref} aria-label={`Call Diamond Salon & Spa at ${contact.phoneDisplay}`}>
            <Phone aria-hidden="true" />
            <span>{contact.phoneDisplay}</span>
          </a>
        </div>
      </div>
      <div className="site-header__inner shell">
        <Logo />
        <nav className="desktop-nav" aria-label="Primary navigation">{navigation}</nav>
        <a className="button button--small header-book" href={contact.bookingUrl} target="_blank" rel="noopener noreferrer">Book Now</a>
        <button ref={menuButtonRef} className="menu-button" type="button" onClick={() => setOpen((value) => !value)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} aria-controls="mobile-navigation">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      <div id="mobile-navigation" className={`mobile-nav${open ? ' mobile-nav--open' : ''}`} aria-hidden={!open}>
        <nav aria-label="Mobile navigation">
          {navigation}
          <a className="button" href={contact.bookingUrl} target="_blank" rel="noopener noreferrer">Book an Appointment</a>
        </nav>
        <p>{contact.address}</p>
      </div>
    </header>
  )
}
